<template>
	<div>
		<h2>{{ $t('tiers.menu_addresses_livraison') }}</h2>

		<div class="box">
			<CustomTable
				ref="table"
				id_table="tiers_addresses"
				:items="addresses"
				:busy.sync="table_busy"
				primaryKey="tiersaddress_id"
			/>
		</div>

		<AddressForm
			ref="address_form"
			:tiers_id="parseInt(tiers_id)"
			@submit="reload"
		/>

		<AddressTraceImport
			ref="trace_import"
			:tiers_id="parseInt(tiers_id)"
			@submit="reload"
			@open-form="openFormFromTrace"
		/>

		<b-modal ref="modal_delete" hide-footer @shown="bindDeleteShortcut" @hidden="unbindDeleteShortcut">
			<template v-slot:modal-title>
				{{ $t('tiers.address.supprimer_titre') }}
			</template>
			<p>{{ $t('tiers.address.supprimer_confirmation') }}</p>
			<div class="row justify-content-around">
				<b-button class="mt-3 btn-block rounded-pill col-5" variant="primary" :disabled="deleting" @click="doDelete">
					<font-awesome-icon v-if="deleting" :icon="['fas', 'spinner']" pulse />
					{{ $t('global.oui') }}
					<span class="ml-1 small text-white-50">({{ isMac ? '⌘' : 'Ctrl' }}+S)</span>
				</b-button>
				<b-button class="mt-3 btn-block rounded-pill col-5" variant="secondary" :disabled="deleting" @click="cancelDelete">
					{{ $t('global.non') }}
				</b-button>
			</div>
		</b-modal>

		<ActionOverlay ref="deleteOverlay" />
	</div>
</template>

<script type="text/javascript">
	import Tiers from "@/mixins/Tiers.js"
	import Navigation from "GroomyRoot/mixins/Navigation.js"

	export default {
		name: "TiersAddressList",
		mixins: [Tiers, Navigation],
		props: ['tiers_id'],
		data() {
			return {
				addresses: [],
				table_busy: true,
				to_delete: null,
				deleting: false,
				deleteHandler: null,
				events_tab: {
					'TableAction::goToAddTiersAddress': () => {
						this.addOrEdit()
					},
					'TableAction::goToEditTiersAddress': (address) => {
						this.addOrEdit(address)
					},
					'TableAction::goToDeleteTiersAddress': (addresses) => {
						this.confirmDelete(addresses)
					},
					'TableAction::goToImportTiersAddressTrace': () => {
						this.$refs.trace_import.open()
					}
				}
			}
		},
		mounted() {
			this.init_component()
		},
		beforeDestroy() {
			this.unbindDeleteShortcut()
		},
		methods: {
			/**
			 * Charge la liste des adresses de livraison du tiers depuis l'API.
			 */
			async init_component() {
				this.table_busy = true
				const res = await this.loadTiersAddress(this.tiers_id)
				this.addresses = Array.isArray(res) ? res : []
				this.table_busy = false
			},
			reload() {
				this.init_component()
			},
			addOrEdit(address = null) {
				this.$refs.address_form.open(address)
			},
			openFormFromTrace(prefill) {
				this.$refs.address_form.open(prefill)
			},
			confirmDelete(addresses) {
				this.to_delete = Array.isArray(addresses) ? addresses : [addresses]
				this.$refs.modal_delete.show()
			},
			cancelDelete() {
				this.to_delete = null
				this.$refs.modal_delete.hide()
			},
			bindDeleteShortcut() {
				this.unbindDeleteShortcut()
				this.deleteHandler = (e) => {
					if ((this.isMac ? e.metaKey : e.ctrlKey) && e.key.toLowerCase() === 's') {
						e.preventDefault()
						if (!this.deleting) {
							this.doDelete()
						}
					}
				}
				window.addEventListener('keydown', this.deleteHandler)
			},
			unbindDeleteShortcut() {
				if (this.deleteHandler) {
					window.removeEventListener('keydown', this.deleteHandler)
					this.deleteHandler = null
				}
			},
			/**
			 * Supprime les adresses sélectionnées après confirmation.
			 * Affiche un overlay de progression et recharge la liste en fin d'opération.
			 */
			async doDelete() {
				if (this.deleting || !this.to_delete || this.to_delete.length === 0) {
					return
				}
				this.deleting = true
				this.$refs.deleteOverlay.show(this.$t('global.suppression_en_cours'))
				let allOk = true
				for (const address of this.to_delete) {
					const ok = await this.deleteTiersAddress(this.tiers_id, address.tiersaddress_id)
					if (!ok) {
						allOk = false
					}
				}
				if (allOk) {
					await this.$refs.deleteOverlay.showSuccess({
						text: this.$t('global.suppression_succes'),
						icon: ['far', 'trash-alt']
					})
				} else {
					this.$refs.deleteOverlay.hide()
					this.failureToast('toast.info_modif_failed')
				}
				this.deleting = false
				this.$refs.modal_delete.hide()
				this.to_delete = null
				if (this.$refs.table && typeof this.$refs.table.unselectAll === 'function') {
					this.$refs.table.unselectAll()
				}
				this.reload()
			}
		},
		components: {
			CustomTable: () => import('GroomyRoot/components/Table/CustomTable'),
			AddressForm: () => import('@/components/Tiers/AddressForm'),
			AddressTraceImport: () => import('@/components/Tiers/AddressTraceImport'),
			ActionOverlay: () => import('@/components/Utils/ActionOverlay')
		}
	}
</script>
